// extracted by mini-css-extract-plugin
module.exports = {"homeTitle":"home_homeTitle__1eluh","productsWrapper":"home_productsWrapper__2P2pu","buttonsWrapper":"home_buttonsWrapper__1DVTR"};